<template>
  <video ref="video">
    <source
      v-if="srcMobile"
      :src="srcMobile"
      :media="`(max-width:${screens.lg}px)`"
    />
    <source :src="src" />
  </video>
</template>

<script setup lang="ts">
import { screens } from "@/configs/breakpointsConfig.json";

defineProps<{
  src: string;
  srcMobile?: string;
}>();

const { lgAndUp } = useAppBreakpoints();
const video = ref<HTMLVideoElement | null>(null);
const firstLoad = ref(true);

watch(
  () => lgAndUp.value,
  () => {
    if (!firstLoad.value) {
      video.value?.load();
      video.value?.play();
    }
    firstLoad.value = false;
  },
);
</script>
